window.jquery = window.jQuery;

function loadOpenAPIFile(name, url) {
  if (window.lucybot.openapi[name]) return;
  window.jQuery.ajax({
    url: url,
    async: false,
    dataType: 'json',
    success: function (response) {
      window.lucybot.openapi[name] = response;
    }
  });
}
if (window.config.loadOpenAPISynchronous) {
  for (var name in window.config.openapi || {}) {
    let firstVersion = window.config.openapi[name][0];
    var filename = 'openapi/' + name + '.' + firstVersion.label.replace(/\W+/g, '_') + '.openapi.json';
    loadOpenAPIFile(name, filename);
  }
}
if (window.config.openapiLocation) {
  loadOpenAPIFile('default', window.config.openapiLocation);
}




// WEBPACK FOOTER //
// src/app/startup.js